<div
  class="w-full p-8 bg-zinc-100 appel-a-candidatures creation flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <!-- Popup succès -->
  <div *ngIf="successMessage" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40"
    [class.success-popup-fadeout]="isClosing">
    <div class="bg-white rounded-2xl shadow-2xl px-10 py-10 flex flex-col items-center gap-4 success-popup-anim">
      <svg class="success-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="success-checkmark-circle" cx="26" cy="26" r="24" fill="none" />
        <path class="success-checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
      </svg>
      <p class="text-lg font-semibold text-gray-800 text-center">
        {{ successMessage }}
      </p>
    </div>
  </div>
  <!-- Popup erreur -->
  <div *ngIf="errorMessage" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-2xl shadow-2xl px-10 py-10 flex flex-col items-center gap-4 error-popup-anim">
      <svg class="error-cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="error-cross-circle" cx="26" cy="26" r="24" fill="none" />
        <path class="error-cross-line1" fill="none" d="M17 17l18 18" />
        <path class="error-cross-line2" fill="none" d="M35 17l-18 18" />
      </svg>
      <p class="text-lg font-semibold text-gray-800 text-center">
        {{ errorMessage }}
      </p>
    </div>
  </div>
  <div class="self-stretch h-full flex-col justify-start items-start gap-6 flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
        <div class="self-stretch text-gray-900 text-4xl font-semibold leading-[38px] mb-5">
          {{ isEditMode ? "Modifier l'appel à candidatures hors parcours" : "Appel à candidatures hors parcours" }}
        </div>
        <div class="self-stretch text-slate-600 text-base font-interRegular leading-normal mb-5">
          {{ isEditMode ? "Formulaire de modification d'appel à candidatures hors parcours" : "Formulaire de création
          d'appel à candidatures hors parcours" }}

        </div>
      </div>
      <form [formGroup]="form" class="w-full">
        <!-- Informations de l'appel -->
        <div class="bg-white rounded-lg shadow dark:bg-gray-700">
          <fieldset class="w-full cst-fieldset pr-db-w1 gap-4 p-6">
            <legend class="font-semibold text-xl pt-6">
              Informations de l'appel
            </legend>

            <div class="p-fluid p-formgrid grid" style="display: flex">
              <div class="cst-line mb-6 field col-12 mb-0 md:mb-4 md:col-6 pb-0 md:pr-0 pr-4">
                <label for="applicationName" class="block text-md mb-2">
                  Titre
                </label>
                <input class="w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1"
                  id="applicationName" type="text" formControlName="applicationName" [ngClass]="{
                      'border-red-500':
                        form.get('applicationName')?.invalid &&
                        form.get('applicationName')?.touched,
                    }" />
                <div *ngIf="isFieldInvalid('applicationName')" class="text-red-500 text-sm">
                  Le titre est obligatoire.
                </div>
              </div>

              <div class="cst-line mb-6 field col-12 mb-0 md:mb-4 md:col-6 pb-0">
                <label for="param" class="block text-md mb-2">
                  Paramètre
                </label>
                <input class="w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1"
                  id="param" type="text" formControlName="param" [ngClass]="{
                      'border-red-500':
                        form.get('param')?.invalid && form.get('param')?.touched,
                    }" />
                <div *ngIf="isFieldInvalid('param')" class="text-red-500 text-sm">
                  Le paramètre est obligatoire.
                </div>
              </div>
            </div>

            <!-- <div class="cst-line mb-6">
              <label for="applicationName" class="block text-md mb-2">
                Titre
              </label>
              <input
                class="w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1"
                id="applicationName"
                type="text"
                formControlName="applicationName"
                [ngClass]="{
                  'border-red-500':
                    form.get('applicationName')?.invalid &&
                    form.get('applicationName')?.touched,
                }"
              />
              <div
                *ngIf="isFieldInvalid('applicationName')"
                class="text-red-500 text-sm"
              >
                Le titre est obligatoire.
              </div>
            </div> -->

            <div class="cst-line mb-6">
              <label for="applicationInformations" class="block text-md mb-2">
                Donnez les détails de l'appel
              </label>
              <textarea class="w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1"
                id="applicationInformations" formControlName="applicationInformations"></textarea>
            </div>

            <div class="p-fluid p-formgrid grid" style="display: flex">
              <div class="cst-line mb-6 field col-12 mb-0 md:mb-4 md:col-6 pb-0 md:pr-0 pr-4">
                <label for="openDate" class="block text-md mb-2">
                  Date d'ouverture des soumissions
                </label>
                <input class="w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1"
                  id="openDate" type="date" formControlName="openDate" [ngClass]="{
                    'border-red-500':
                      form.get('openDate')?.invalid &&
                      form.get('openDate')?.touched,
                  }" />
                <div *ngIf="
                    form.get('openDate')?.invalid &&
                    form.get('openDate')?.touched
                  " class="text-red-500 text-sm">
                  La date d'ouverture est requise.
                </div>
              </div>

              <div class="cst-line mb-6 field col-12 mb-0 md:mb-4 md:col-6 pb-0">
                <label for="closeDate" class="block text-md mb-2">
                  Date de fermeture des soumissions
                </label>
                <input class="w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1"
                  id="closeDate" type="date" formControlName="closeDate" [ngClass]="{
                    'border-red-500':
                      form.get('closeDate')?.invalid &&
                      form.get('closeDate')?.touched,
                  }" />
                <div *ngIf="
                    form.get('closeDate')?.invalid &&
                    form.get('closeDate')?.touched
                  " class="text-red-500 text-sm">
                  La date de fermeture est requise.
                </div>
              </div>
            </div>

            <!-- Certificats List -->
            <!--formArrayName="certificatsList"-->
            <div>
              <table valign="top" class="w-full text-sm text-left rtl:text-right text-black-500 dark:text-black-400">
                <thead>
                  <tr>
                    <th class="grid-cols-9">Type d'appel</th>
                    <th class="grid-cols-3">Cohortes</th>
                  </tr>
                </thead>
                <tbody valign="top">
                  <tr>
                    <td class="px-1 py-1 prerequis-td">
                      <select
                        class="appearance-none block w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1 leading-tight focus:outline-none focus:bg-white"
                        formControlName="applicationType">
                        <option value="CERTIFICAT">CERTIFICAT</option>
                      </select>
                      <div *ngIf="isFieldInvalid('applicationType')" class="text-red-500 text-sm">
                        Le type de l'appel est obligatoire.
                      </div>
                    </td>
                    <td class="px-1 py-1 prerequis-td">
                      <select
                        class="appearance-none block w-full rounded-lg shadow border border-gray-300 cst-transition rounded py-1 px-1 leading-tight focus:outline-none focus:bg-white"
                        (change)="onCohorteChange($event)" formControlName="cohorte"
                        [ngClass]="{ 'border-red-500': !selectedCohorte }">
                        <option *ngFor="let cohorte of cohorteOption" [value]="cohorte">
                          {{ cohorte }}
                        </option>
                      </select>
                      <div *ngIf="isFieldInvalid('cohorte')" class="text-red-500 text-sm">
                        La cohorte est obligatoire.
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>
        </div>

        <!-- Certificat Choisi -->
        <div class="bg-white rounded-lg shadow dark:bg-gray-700">
          <fieldset class="w-full cst-fieldset pr-db-w1 gap-4 p-6">
            <legend class="font-semibold text-xl pt-6">
              Certificat pour l'appel
            </legend>

            <div formArrayName="certificatChoiceList">
              <table valign="top" class="w-full text-sm text-left rtl:text-right text-black-500 dark:text-black-400">
                <tbody valign="top">
                  <tr>
                    <td class="px-1 py-1 prerequis-td">
                      <div class="md:grid-cols-3 gap-6">
                        <div class="relative z-0 w-full mb-5 group">
                          <div class="col-span-1 label">
                            <div class="lg:flex lg:me-3">
                              Merci de choisir les certificats pour l'appel :
                              &nbsp;
                            </div>
                          </div>
                        </div>

                        <div *ngIf="
                            certificatDynamicOption &&
                            certificatDynamicOption.length > 0
                          " class="box-certificats relative z-0 w-full group grid grid-cols-2 gap-1 gap-x-24 m-0">
                          <div *ngFor="
                              let certificat of certificatDynamicOption;
                              let i = index
                            " class="col-span-1 mb-4">
                            <div class="flex items-center">
                              <input type="checkbox" [id]="'certificat_' + certificat.ExternalId" style="width: 1.25rem"
                                class="h-5 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500" (change)="
                                  onCheckboxChange(
                                    $event,
                                    certificat.ExternalId
                                  )
                                " [checked]="
                                  selectedCertificates.includes(
                                    certificat.ExternalId
                                  )
                                " />
                              <label [for]="'certificat_' + certificat.ExternalId"
                                class="ml-2 text-sm font-medium text-gray-900">
                                {{ certificat.certificatName }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="
                            certificatDynamicOption.length === 0 &&
                            selectedCohorte
                          " class="text-gray-500">
                          Chargement des certificats...
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>
        </div>

        <button
          class="cst-before cst-after cst-transition bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="submit" (click)="openConfirmModal()">
          {{ isEditMode ? "Enregistrer les modifications" : "Créer l'appel à candidature" }}
        </button>
      </form>
    </div>
    <!-- Modal de confirmation -->
    <div *ngIf="showConfirmModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6">
        <!-- Icône + Titre -->
        <div class="flex flex-col items-center gap-3 text-center">
          <div class="bg-green-100 rounded-full p-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 class="text-2xl font-semibold text-gray-900">
            {{ isEditMode ? "Confirmer la modification" : "Confirmer la création" }}
          </h2>
          <p class="text-slate-600 text-base">
            {{ isEditMode
            ? "Vous êtes sur le point de modifier cet appel à candidatures hors parcours."
            : "Vous êtes sur le point de créer un appel à candidatures hors parcours." }}<br />
            Voulez-vous confirmer cette action ?
          </p>
        </div>

        <!-- Récapitulatif -->
        <div class="bg-zinc-50 rounded-lg border border-gray-200 px-5 py-4 text-sm text-gray-700 flex flex-col gap-2">
          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Titre :</span>
            <span class="font-semibold">{{
              form.get("applicationName")?.value
              }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Paramètre :</span>
            <span>{{ form.get("param")?.value }}</span>
          </div>

          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Type :</span>
            <span>{{ form.get("applicationType")?.value }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Cohorte :</span>
            <span>{{ selectedCohorte }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Ouverture :</span>
            <span>{{ form.get("openDate")?.value }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Fermeture :</span>
            <span>{{ form.get("closeDate")?.value }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-medium text-gray-500">Certificats sélectionnés :</span>
            <span>{{ selectedCertificates.length }}</span>
          </div>
        </div>

        <!-- Boutons -->
        <div class="flex justify-end gap-3">
          <button (click)="cancelSubmit()"
            class="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 cst-transition focus:outline-none">
            Annuler
          </button>
          <button (click)="confirmSubmit()"
            class="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-700 text-white font-bold cst-transition focus:outline-none focus:shadow-outline">
            Confirmer
          </button>
        </div>
      </div>
    </div>
  </div>
</div>